export default {
  SYSTEM_SET(state, [field, value]) {
    if (field.includes('.')) {
      const subField = field.split('.')
      state[subField[0]][subField[1]] = value
    } else {
      state[field] = value
    }
  },
  SYSTEM_ASSIGN(state, { field, key, value }) {
    if (value) {
      state[field] = Object.assign({ ...state[field] }, { [key]: value })
    } else {
      const obj = Object.assign({}, state[field])
      delete obj[key]
      state[field] = obj
    }
  }
}
